import React, { useState } from 'react'
import { usePersistedState } from '../../../hooks/usePersistedState'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { Box, LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { useAppSelector } from '../../../app/hooks'
import { sectionApiSlice } from '../../../features/section/sectionSlice'
import Breadcrumb from '../../../components/Breadcrumb'
import GroupsTable from './components/GroupsTable'
import MonthWeekFilter from '../../../components/monthWeekFilter/MonthWeekFilter'
import { useHeadScope } from '../../head/headScope'
import DirectorSubjectFilter from '../../director/DirectorSubjectFilter'
import { ui } from '../../../utils/uiTokens'

const GroupListPage = () => {
    const { formatMessage } = useIntl()
    const { id } = useAppSelector((state) => state.user.userInfo)
    // басшы: 0 = все менторы его предметов
    const { readOnly } = useHeadScope()
    const [monthNumber, setMonthNumber] = usePersistedState<number | undefined>('curator.monthNumber', undefined)
    const [weekNumber, setWeekNumber] = usePersistedState<number | undefined>('curator.weekNumber', undefined)
    const { data: groups = [], isFetching } =
        sectionApiSlice.useGetGroupsSectionAnalysisQuery({
            curatorId: readOnly ? 0 : id,
            monthNumber,
            weekNumber,
        })

    // Проценты считаются по темам выбранного периода
    const handlePeriodChange = (month?: number, week?: number) => {
        setMonthNumber(month)
        setWeekNumber(week)
    }

    return (
        <Wrapper>
            <Breadcrumb links={[formatMessage({ id: 'groups' })]} />

            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'groups' })}</H3>
                    </Title>

                    <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center' }}>
                        <DirectorSubjectFilter />
                        <MonthWeekFilter
                            monthNumber={monthNumber}
                            weekNumber={weekNumber}
                            onChange={handlePeriodChange}
                        />
                    </Box>
                </Header>

                {isFetching && <LinearProgress />}

                <GroupsTable
                    groups={groups}
                    isFetching={isFetching}
                />
            </Content>
        </Wrapper>
    )
}

export default GroupListPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
    color: ${ui.ink};
`

const Content = styled.div`
    background-color: ${ui.card};
    border: 1px solid ${ui.border};
    border-radius: 16px;
    padding: 24px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
`
